const primary = {
  100: '#EC5A4D',
  200: '#EC5A4D',
  300: '#EC5A4D',
  400: '#EC5A4D',
  500: '#EC5A4D'
};

export default primary;
